function overflow(state) {
  let body = document.querySelector('body');

  body.style.overflow = state;
}

export default overflow;
